import { render, staticRenderFns } from "./ModalDocumentosAssincronos.vue?vue&type=template&id=3a60e495&scoped=true&lang=pug"
import script from "./ModalDocumentosAssincronos.vue?vue&type=script&lang=js"
export * from "./ModalDocumentosAssincronos.vue?vue&type=script&lang=js"
import style0 from "./ModalDocumentosAssincronos.vue?vue&type=style&index=0&id=3a60e495&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a60e495",
  null
  
)

export default component.exports